import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download_3pYuE",
  "use": "download_3pYuE-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download_3pYuE\">\n    <line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\" stroke=\"currentColor\" />\n    <polyline points=\"8,11 12,15 16,11\" stroke=\"currentColor\" fill=\"none\" />\n    <rect x=\"5\" y=\"15\" width=\"14\" height=\"6\" stroke=\"currentColor\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol